__webpack_require__.p = "https://tehnosvet.portal.penalbox.by/";